"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var PageLoader_1 = __importDefault(require("../../../../../components/PageLoader"));
var SubscriptionPlans_1 = __importDefault(require("../../../../../components/SubscriptionPlans"));
var react_redux_1 = require("react-redux");
var subscriptionSlice_1 = require("../../../../../features/subscription/subscriptionSlice");
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var SellSpecialist = function () {
    var subscriptionPlans = react_redux_1.useSelector(subscriptionSlice_1.subscriptionPlansData);
    var _a = react_1.useState(true), loading = _a[0], setLoading = _a[1];
    react_1.useEffect(function () {
        subscriptionPlans.length && setLoading(false);
    }, [subscriptionPlans]);
    var onSubscribe = function () {
        // TODO need to write logic!
    };
    return loading ? (react_1.default.createElement(PageLoader_1.default, null)) : (react_1.default.createElement("div", { className: styles_module_scss_1.default.sell_specialist },
        react_1.default.createElement(SubscriptionPlans_1.default, { onSubscribe: onSubscribe, plans: [subscriptionPlans[1]] })));
};
exports.default = SellSpecialist;
